import React from "react";
import BackgroundHeadPrimary from "assets/images/bg-head-portfolio.jpg";
import logo from "assets/images/logo.png";
import styled from "styled-components";
import { NotificationSelector } from "redux/selector/notification";
import { useSelector } from "react-redux";
import { MncVars } from "const";
import { useMeasureForCssVar } from "components/hooks";

const use = [["height", MncVars.Header]];

function MoneyConnectHeader2({ height, setIsVisible }) {
  const [headerRef] = useMeasureForCssVar({ use });
  const notiList = useSelector(NotificationSelector.notificationList);

  return (
    <HeaderPrimary ref={headerRef} $height={height}>
      <div className="bg-header"></div>
      <div className="container">
        <div className="position-relative">
          <div className="header-content">
            <div className="logo-mnc">
              <img src={logo} className="w-100" alt="logo preview" />
            </div>
            <div className="notification-main" onClick={() => setIsVisible(true)}>
              {notiList.length > 0 && <div className="notification-number">{notiList.length}</div>}
              <i className="feather-icon icon-bell"></i>
            </div>
          </div>
        </div>
      </div>
    </HeaderPrimary>
  );
}

export default MoneyConnectHeader2;

const HeaderPrimary = styled.div`
  .bg-header {
    position: absolute;
    background-image: url(${BackgroundHeadPrimary});
    background-size: cover;
    background-position: bottom;
    width: 100%;
    height: ${(props) => props.$height}px;
    border-bottom-left-radius: 50% 18%;
    border-bottom-right-radius: 50% 18%;
    h2 {
      color: white;
    }
  }
  .header-content {
    padding: 20px 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .logo-mnc {
      width: 180px;
    }

    .notification-main {
      position: relative;
      .notification-number {
        top: -7px;
        left: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 4px;
        height: 16px;
        min-width: 16px;
        text-align: center;
        line-height: 16px;
        position: absolute;
        background: var(--ktb-red);
        color: white;
        font-size: 14px;
        border-radius: 30rem;
      }
      i {
        color: white;
        font-size: 24px;
      }
    }
  }
`;
